export const SET_FORMAT = (state, value) => {
  state.format = value
}

export const SET_PDF_FORMAT = (state, value) => {
  state.pdftemplate = value
}

export const SET_LOGO = (state, value) => {
  state.logofile.file = value
}

export const SET_OWNER_FORMAT = (state, value) => {
  state.xsltfile.file = value
}

export const SET_NAME = (state, value) => {
  state.xsltfile.name = value
}

export const SET_LOGOFILENAME = (state, value) => {
  state.logofile.name = value
}
